import { __extends } from "tslib";
import { Backend } from './base';
var MyBackend = /** @class */ (function (_super) {
    __extends(MyBackend, _super);
    function MyBackend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sdk = my;
        return _this;
    }
    MyBackend.prototype.normalizeEnvInfo = function (systemInfo, networkStatus) {
        return {
            host_platform: 'my',
            host_app_name: systemInfo.app,
            host_app_version: systemInfo.version,
            platform: systemInfo.platform,
            sdk_version: systemInfo.SDKVersion,
            os_name: systemInfo.platform,
            os_version: systemInfo.system,
            device_brand: systemInfo.brand,
            device_model: systemInfo.model,
            screen_width: systemInfo.screenWidth,
            screen_height: systemInfo.screenHeight,
            resolution: systemInfo.screenWidth + 'x' + systemInfo.screenHeight,
            pixel_ratio: systemInfo.pixelRatio,
            network_type: networkStatus.networkType,
        };
    };
    return MyBackend;
}(Backend));
export default MyBackend;
//# sourceMappingURL=my.js.map